export default {
  meEndpoint: '/v1/me',
  loginEndpoint: '/v1/auth/login',
  logoutEndpoint: '/v1/auth/logout',
  registerEndpoint: '/v1/auth/register',
  forgotPasswordEndpoint: '/v1/users/recover-password/send-email',
  resetPasswordEndpoint: '/v1/users/recover-password/password',
  storageTokenKeyName: 'accessToken'
}
